import React from 'react';
import { createRoot } from 'react-dom/client';
import createStore from './store/createStore';
import AppContainer from './containers/AppContainer';
import localizationConf from '../../../bin/localizationConf';

// ========================================================
// Полифил для structuredClone
// ========================================================
if (typeof window.structuredClone !== 'function') {
  import('structured-clone').then((module) => {
    window.structuredClone = module.clone;
  });
}

// ========================================================
// Язык локализации
// ========================================================
let locale = navigator.language;
if (localizationConf.locales.indexOf(locale) === -1) {
  locale = 'en';
}

// ========================================================
// Инициализация Store
// ========================================================
const store = createStore();

// ========================================================
// Настройка рендера
// ========================================================
const MOUNT_NODE = document.getElementById('root');
const ROOT_NODE = createRoot(MOUNT_NODE);

let render = (messages) => {
  // Если нет объекта Intl, то загружаем полифил
  const App = (
    <AppContainer store={store} messages={messages} locale={locale} />
  );
  if (!window.Intl) {
    require.ensure(
      [],
      (require) => {
        require('intl');
        require('intl/locale-data/jsonp/en.js');
        ROOT_NODE.render(App);
      },
      'intl'
    );
  } else {
    ROOT_NODE.render(App);
  }
};

// ========================================================
// Динамическая загрузка файла локализации
// ========================================================
import(`../../../messages/app/${locale}.json`).then((messages) => {
  messages = messages.default;
  if (__DEV__) {
    // Development render functions
    const renderApp = render;
    const renderError = (error) => {
      const RedBox = require('redbox-react').default; // NOSONAR
      ROOT_NODE.render(<RedBox error={error} />);
    };

    // Обертка рендера в try/catch
    render = (mes) => {
      try {
        renderApp(mes);
      } catch (error) {
        console.error(error); // eslint-disable-line no-console
        renderError(error);
      }
    };
  }
  // ========================================================
  // Запуск приложения
  // ========================================================
  render(messages);
});
